import React from 'react';
import PropTypes from 'prop-types';

import Icon, { GLYPHS } from '../../../common/icon';
import { t } from '../../../../modules/infra/i18n';

const options = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(option => option.toString());

const Scale11 = (props) => {
  return (
    <div>
      <p className="c-nps-scale-popup__title">
        {props.title}
      </p>
      <div className="c-nps-scale-popup__options">
        {
          options.map(option => (
            <button
              key="option"
              className="c-nps-scale-popup__option"
              onClick={() => props.onOptionClick(option)}
            >
              {option}
            </button>
          ))
        }
      </div>
      <div className="c-nps-scale-popup__legend">
        <p>{t('common:scale11.not_at_all_likely')}</p>
        <p>{t('common:scale11.extremely_likely')}</p>
      </div>
      <button
        className="c-nps-scale-popup__close"
        onClick={props.onClose}
      >
        <Icon glyph={GLYPHS.close} />
      </button>
    </div>
  );
};

Scale11.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onOptionClick: PropTypes.func.isRequired,
};

export default Scale11;
